// extracted by mini-css-extract-plugin
export var equalColumn = "_j8-0";